module.exports = __webpack_public_path__ + "img/icon-info-blanc.41269c0e.svg";